import React from 'react';

const Landing: React.FC = () => {
  return (
    <div className="flex items-start justify-center" style={{ paddingTop: 'calc(2rem + 0.08cm)', paddingBottom: 'calc(1rem - 0.5cm)' }}>
      <div className="w-full max-w-4xl mx-auto text-center space-y-8">
        <div className="photo-frame max-w-3xl mx-auto">
          {/* Desktop/Tablet Image */}
          <img 
            src="/images/landing/0N7A8704_optimized.jpg" 
            alt="Shivangi and Ishan" 
            className="w-full h-auto hidden sm:block"
            loading="lazy"
            decoding="async"
          />
          {/* Mobile Image */}
          <img 
            src="/images/landing/DSC06255_optimized.jpg" 
            alt="Shivangi and Ishan" 
            className="w-full h-auto block sm:hidden"
            loading="lazy"
            decoding="async"
          />
        </div>
        <br></br>
        <p className="text-sage-grey-600 max-w-2xl mx-auto leading-relaxed">
          We're getting married and would love for you to join us in celebrating our special day.
        </p>
      </div>
    </div>
  );
};

export default Landing;